export default __webpack_public_path__ + "static/Deeper-dive-marlene-mcneese-profile-mobile-8d75ad01947a064072d400d9b1270120.png";